import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import Lenis from 'lenis'

gsap.registerPlugin(ScrollTrigger)

const lenis = new Lenis({ allowNestedScroll: true })
window.lenis = lenis;

lenis.on('scroll', ScrollTrigger.update)

gsap.ticker.add((time) => {
    lenis.raf(time * 1000)
})

gsap.ticker.lagSmoothing(0)

/*
 * Cursor Follow
 *
 * Add .cursor-parent to container
 * Add .cursor-follow to element
 */
const $cursorParents = document.querySelectorAll('.cursor-parent')

$cursorParents?.forEach(($parent) => {
    const $follower = $parent.querySelector('.cursor-follow')
    if (!$follower) return

    let pos = {
        x: $parent.offsetWidth / 2,
        y: $parent.offsetHeight / 2
    }
    let mouse = { ...pos }
    const speed = 0.2
    const fpms = 60 / 1000

    $parent.addEventListener('pointermove', (e) => {
        const rect = $parent.getBoundingClientRect()
        mouse.x = e.clientX - rect.left
        mouse.y = e.clientY - rect.top
    })

    const xSet = gsap.quickSetter($follower, 'x', 'px')
    const ySet = gsap.quickSetter($follower, 'y', 'px')

    const $followerOffset = {
        x: $follower.offsetWidth / 2,
        y: $follower.offsetHeight / 2,
    }

    gsap.ticker.add((time, deltaTime) => {
        let delta = deltaTime * fpms
        let dt = 1.0 - Math.pow(1.0 - speed, delta)
        pos.x += (mouse.x - pos.x) * dt
        pos.y += (mouse.y - pos.y) * dt
        xSet(pos.x - $followerOffset.x)
        ySet(pos.y - $followerOffset.y)
    })
})
